import { Image } from '../../components';

export function AtmCardPreview(props: { width?: number }) {
  return (
    <Image
      src="/static/assets/atm_card_info.png"
      alt="Visual description of where the identification and serial number is on the ATM card."
      {...props}
    />
  );
}
